import React, { useState, useEffect } from 'react';
import '../styles.css';

const UPSStatus = () => {
  const [batteryVoltage, setBatteryVoltage] = useState(null);
  const [loadLevel, setLoadLevel] = useState(null);
  const [backupTime, setBackupTime] = useState(null);
  const [connectionStatus, setConnectionStatus] = useState('Disconnected');
  const [lastUpdate, setLastUpdate] = useState(null);
  const [mainCurrentVoltage, setMainCurrentVoltage] = useState(null);
  const [upsCurrentVoltage, setUPSCurrentVoltage] = useState(null);

  const CHANNEL_ID = '3018449';
  const READ_API_KEY = 'WPIXJNON8E0WC5U0';

  const getThingSpeakUrl = () => {
    const baseUrl = `https://api.thingspeak.com/channels/${CHANNEL_ID}/feeds/last.json`;
    return READ_API_KEY ? `${baseUrl}?api_key=${READ_API_KEY}` : baseUrl;
  };

  const OFFLINE_THRESHOLD_MINUTES = 5;

  useEffect(() => {
    const fetchUPSData = async () => {
      try {
        setConnectionStatus('Fetching...');
        const response = await fetch(getThingSpeakUrl());
        if (response.ok) {
          const data = await response.json();

          if (!data.created_at) {
            setConnectionStatus('Device Offline');
            clearUPSData();
            return;
          }

          const lastUpdateTime = new Date(data.created_at);
          const now = new Date();
          const diffMinutes = (now - lastUpdateTime) / 1000 / 60;

          if (diffMinutes > OFFLINE_THRESHOLD_MINUTES) {
            setConnectionStatus('Device Offline');
            clearUPSData();
            return;
          }

          setBatteryVoltage(data.field1 ? parseFloat(data.field1) : null);
          setLoadLevel(data.field2 ? parseInt(data.field2) : null);
          setBackupTime(data.field3 || null);
          setMainCurrentVoltage(data.field4 ? parseFloat(data.field4) : 0);
          setUPSCurrentVoltage(data.field5 ? parseFloat(data.field5) : 0);

          setConnectionStatus('Connected');
          setLastUpdate(lastUpdateTime.toLocaleTimeString());
        } else {
          setConnectionStatus('Error Fetching Data');
        }
      } catch (error) {
        console.error('ThingSpeak fetch error:', error);
        setConnectionStatus('Error');
      }
    };

    const clearUPSData = () => {
      setBatteryVoltage(null);
      setLoadLevel(null);
      setBackupTime(null);
      setLastUpdate(null);
      setMainCurrentVoltage(null);
      setUPSCurrentVoltage(null);
    };

    fetchUPSData();
    const interval = setInterval(fetchUPSData, 30000);
    return () => clearInterval(interval);
  }, []);

  const getMainCurrentStatus = () =>
    typeof mainCurrentVoltage === 'number' && mainCurrentVoltage > 0 ? 'UP' : 'DOWN';

  const getUPSCurrentStatus = () =>
    typeof upsCurrentVoltage === 'number' && upsCurrentVoltage > 0 ? 'UP' : 'DOWN';

  return (
    <div className="main-content">
      <div className="ups-container">
        <div className="header-section">
          <h2>UPS Status ⚡</h2>
          <div
            className="connection-status"
            style={{
              color: connectionStatus === 'Connected' ? '#22cf27ff' : '#f44336',
              fontSize: '14px',
              marginBottom: '10px',
            }}
          >
            <strong>ThingSpeak Status:</strong> {connectionStatus}
            {lastUpdate && <span style={{ marginLeft: '15px' }}>Last Update: {lastUpdate}</span>}
          </div>
        </div>

        <div className="ups-units">
          {connectionStatus === 'Device Offline' ? (
            <div
              style={{
                color: '#f44336',
                fontWeight: 'bold',
                textAlign: 'center',
                padding: '20px',
                fontSize: '16px',
              }}
            >
              ⚠️ Device Offline or No Recent Data
            </div>
          ) : (
            <>
              <div className="ups-unit">
                <h3>Main Current</h3>
                <div className="status-card">
                  <span className="status-icon ups-icon">⚡</span>
                  <div className="status-info">
                    <p style={{ color: 'black', textAlign: 'initial',fontSize:'16px' }}>
                      Status:{' '}
                      <span className={getMainCurrentStatus() === 'UP' ? 'status-up' : 'status-down'}>
                        {getMainCurrentStatus()}
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="ups-unit">
                <h3>UPS Current</h3>
                <div className="status-card">
                  <span className="status-icon ups-icon">⚡</span>
                  <div className="status-info">
                    <p style={{ color: 'black', textAlign: 'initial',fontSize:'16px' }}>
                      Status:{' '}
                      <span className={getUPSCurrentStatus() === 'UP' ? 'status-up' : 'status-down'}>
                        {getUPSCurrentStatus()}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="ups-unit">
            <h3>Status</h3>
            <div className="status-card">
              <div className="status-info">
                <h3>Case 01</h3>
                <p>
                  Main Current:<span style={{ color: 'green' }}>UP</span>
                </p>
                <p>
                  UPS Current:<span style={{ color: 'red' }}>DOWN</span>
                </p>
                <p>Status:<span style={{color:'blue'}}>UPS Fault. Need to Check UPS.</span></p>
                <h3>Case 02</h3>
                <p>
                  Main Current:<span style={{ color: 'red' }}>DOWN</span>
                </p>
                <p>
                  UPS Current:<span style={{ color: 'red' }}>DOWN</span>
                </p>
                <p>Status:<span style={{color:'blue'}}>Power Cut and UPS Power is Down.</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UPSStatus;
